module.exports = __webpack_public_path__ + "static/media/AbrilFatface-Regular.28195c14.ttf";